import baseFetch, { getAccessToken } from 'common/baseFetch';

interface ErrorWithResponse extends Error {
  response?: Response;
}

export interface RedeemGiftCodeParams {
  code: string;
  brand?: string;
}

export interface RedeemGiftCodeResponse {
  subscription: Record<string, unknown>;
  accountBalance?: number | null;
}

/**
 * Redeem a gift or scoped-access (LTA) code for the authenticated user.
 */
export const redeemGiftCode = async ({
  code,
  brand = 'sl',
}: RedeemGiftCodeParams): Promise<RedeemGiftCodeResponse> => {
  const accessToken = getAccessToken();
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...(accessToken ? { 'X-Auth-AccessToken': accessToken } : {}),
  };
  try {
    return await baseFetch<RedeemGiftCodeResponse>('/gift/redeem', {
      method: 'POST',
      headers,
      body: JSON.stringify({ code, brand }),
    });
  } catch (error) {
    // baseFetch throws on non-2xx before parsing the body — pull the API's
    // user-facing message (e.g. "You have already redeemed this code") off
    // the response so callers can display it.
    const response = (error as ErrorWithResponse).response;
    if (response) {
      const body = await response.json().catch(() => null);
      if (body?.message) throw new Error(body.message);
    }
    throw error;
  }
};
